/**
 * Created by Bob.Gear on 11/03/14.
 */
//------------------------------------------------------------------------
//  contractTypeFilter Directive
//------------------------------------------------------------------------
angular.module("EICDataStream3.queryBuilder")
  .controller('windTurbineManufacturersFilterController', ['$scope', 'lookupTables',
      function ($scope, lookupTables) {
        $scope.componentName = "windTurbineManufacturersFilter";

        $scope.windTurbineManufacturers = lookupTables.windTurbineManufacturers();

        $scope.resetFilter = function () {
          $scope.clearSelections();
        };

        $scope.clearSelections = function () {
          $scope.criteria.selectedWindTurbineManufacturers = null;
          delete $scope.criteria["selectedWindTurbineManufacturers"];
        };

        $scope.removeFilter = function () {
          $scope.resetFilter();
          $scope.$parent.removeFilter("#windTurbineManufacturersFilter");
        };


        $scope.$watch("criteria.selectedWindTurbineManufacturers.length", function () {
          if (!$scope.criteria.selectedWindTurbineManufacturers) return;

          $scope.selectedCount = $scope.criteria.selectedWindTurbineManufacturers.length;
          $scope.plural = ($scope.selectedCount > 0) ? "" : "s";
        });

      }])
  .directive('windTurbineManufacturersFilter', ['$compile',
      function ($compile) {
        return {
          replace:     true,  // replace the placeholder element with the template
          restrict:    'A',   // usage: <div projectNameFilter />
          templateUrl: "../app-ds3/search/queryBuilder/filters/windTurbineManufacturersFilter.tmpl.html",

          link: function ($scope, iElement, iAttrs) {
          },

          controller: 'windTurbineManufacturersFilterController'
        };
      }]);
//------------------------------------------------------------------------
